export const DEFAULT_PAGE_SIZE = 25;

/**
 * Distribution buckets shown in the score histogram, high → low. Bar colors are
 * the admin sentiment tokens from constants/variables.scss (success → warn →
 * danger): $reports-pill-success-fg, $mode-accent-whitelist, $text-warning,
 * $reports-sync-warn-fg, $mode-accent-disabled.
 */
export const DISTRIBUTION_BUCKETS = [
    { bucket: '9-10', color: '#15803d' },
    { bucket: '7-8', color: '#16a34a' },
    { bucket: '5-6', color: '#f59e0b' },
    { bucket: '3-4', color: '#d97706' },
    { bucket: '1-2', color: '#ef4444' },
];
export const DEFAULT_FILTERS = {
    timeFrame: '30d',
    sortBy: 'timestamp',
    sortOrder: 'desc',
};

export const TIME_FRAME_OPTIONS = [
    { label: 'MTD   ', value: '30d' },
    { label: '3MTD', value: '3m' },
    { label: '6MTD', value: '6m' },
    { label: 'YTD', value: '12m' },
    { label: 'Custom', value: 'custom' },
];
